import { useSelector } from "react-redux";
import { initialLoadingState, loadingStateSelector } from "./loadingReducer";
import { LoadingSlots } from "~/api/data-schema";

export function useLoadingSlot(slot: LoadingSlots): boolean {
    const state = useSelector(loadingStateSelector) || initialLoadingState;
    return state[slot] || false;
}
